// Source/Bonus-Link/Component.ts
class BonusLink extends HTMLElement {
  controller = new AbortController;
  connectedCallback() {
    const { signal } = this.controller;
    const onOpen = this.onOpen.bind(this);
    this.button.addEventListener("click", onOpen, {
      capture: true,
      signal
    });
  }
  disconnectedCallback() {
    this.controller.abort();
  }
  onOpen(event) {
    event.stopImmediatePropagation();
    event.preventDefault();
    this.dialog.showModal();
  }
  get button() {
    return this.querySelector(`button`);
  }
  get dialog() {
    return this.querySelector(`.Bonus-Popup-Dialog`);
  }
}

// Source/Bonus-Link/mod.ts
customElements.define("bonus-link", BonusLink);
